import { render, staticRenderFns } from "./GroupMessageAction.vue?vue&type=template&id=73472a19"
import script from "./GroupMessageAction.vue?vue&type=script&lang=js"
export * from "./GroupMessageAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports